/**
 * Types the office packages share without depending on each other: enums, interfaces and aliases only. The package
 * imports nothing, so anything may depend on it without inheriting other dependencies.
 */

/** The roles a source column can take in a visual: the vocabulary the readers, the toolbar and the pane share */
export enum MeasureRoles {
    Values = "Values",
    PreviousYear = "PreviousYear",
    Plan = "Plan",
    Forecast = "Forecast",
    Comments = "Comments",
}

export enum CategoricalRoles {
    Category = "Category",
    Group = "Group",
}

export type FieldRole = MeasureRoles | CategoricalRoles;

/** A cell as Excel returns it in `Range.values`; the data editor's grid holds the same kinds of value as text */
export type CellValue = string | number | boolean;

/** Whether a source column holds text or numbers, decided from its cells below the header */
export type SourceColumnKind = "text" | "measure";

/** A column of a non-pivot source (Excel range or table, PowerPoint grid, linked data), as the Fields list shows it */
export interface SourceColumn {
    /** The column's position in the source, zero-based */
    index: number;
    /** The header cell, trimmed; empty when the header is blank */
    name: string;
    kind: SourceColumnKind;
}

/** The Flagsmith flag that turns the Fields list and the drag feedback on in the Data fields pane of both products */
export const FIELDS_LIST_FLAG = "fields-list";
